<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }"
      style="background: transparent; box-shadow: none;">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
                <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span
                class="ml-5 text-danger font-weight-bold">บันทึกเวลาปฏิบัติงาน</span>
            </h6>
            <p class="form-sub-title font-web ml-20">&nbsp;&nbsp;Time Saving Request Form</p>
          </a-col>
        </a-row>
      </template>
      <!-- form -->
      <a-row :gutter="24" type="flex" align="stretch">
        <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" class="h-full">
          <historyRequest :dataRequest="dataHistory" textHead="รายการคำขอบันทึกเวลาปฏิบัติงาน"
            :loadingList="loadingList" class="h-full" />
        </a-col>
        <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
          <div class="form-container">
            <!-- Alert คำชี้แจงแบบฟอร์ม -->
            <a-alert type="info" show-icon class="mb-20 font-web notice-savetime-box">
              <span slot="message" class="font-weight-bold" style="font-size: 14px;">
                คำชี้แจงการขอบันทึกเวลาปฏิบัติงาน (Time Recording Request)
              </span>
              <div slot="description" class="mt-5" style="font-size: 13px; line-height: 1.6; color: #4a5568;">
                <p class="mt-0 mb-5">
                  แบบฟอร์มนี้ใช้สำหรับกรณี<strong>มาปฏิบัติงานจริง</strong>
                  แต่ไม่สามารถบันทึกเวลาที่เครื่องตอกบัตรตามจุดบริการต่างๆ ได้
                </p>
                <div class="font-weight-bold mb-5" style="color: #2d3748;">
                  กรณีที่สามารถยื่นคำขอได้ เช่น:
                </div>
                <ul class="mb-10 pl-20" style="list-style-type: disc;">
                  <li>ไปปฏิบัติงานหรือติดต่องานภายนอกวิทยาลัย</li>
                  <li>เครื่องตอกบัตรขัดข้อง หรือมีปัญหาในการให้บริการ</li>
                  <li>ลืมบัตรประจำตัวพนักงาน หรือบัตรชำรุด/สูญหาย</li>
                  <li>กรณีจำเป็นอื่นๆ ที่เกี่ยวข้องกับการปฏิบัติหน้าที่</li>
                </ul>
                <div class="text-danger font-weight-bold" style="font-size: 12.5px;">
                  <a-icon type="exclamation-circle" class="mr-5" />
                  หมายเหตุสำคัญ: แบบฟอร์มนี้ไม่ใช่การขออนุมัติลา ขาดงาน หรือการไปอบรม/สัมมนา (กรณีลาหยุด
                  หรือไปอบรมสัมมนา
                  กรุณาใช้แบบฟอร์มคำขอเฉพาะตามระเบียบ)
                </div>
              </div>
            </a-alert>

            <a-form :layout="'horizontal'">
              <a-descriptions bordered title="" size="small">
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      วันที่ <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-date-picker v-model="formTimeSave.selected_date" :disabled-date="disabledBlockDate"
                    format="YYYY-MM-DD" placeholder="" :mode="['date']" />
                </a-descriptions-item>
                <a-descriptions-item :span="3">

                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      ประเภท <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-radio-group v-model="sel_type" button-style="solid">
                    <a-radio-button v-for="(r, index) in ['ทั้งวัน', 'เวลาเข้างาน', 'เวลาออกงาน']" :key="'r' + index"
                      :value="r">
                      <p class="mt-0 mb-0 font-web">{{ r }}</p>
                    </a-radio-button>
                  </a-radio-group>
                </a-descriptions-item>
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      เวลาเข้างาน
                      <span v-if="['เวลาเข้างาน', 'ทั้งวัน'].includes(sel_type)" class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-form-item extra="" class="font-web mt-5 mb-0">
                    <a-time-picker :disabled="!(sel_type === 'ทั้งวัน' || sel_type === 'เวลาเข้างาน')" format="HH:mm"
                      v-model="formTimeSave.start_time" />
                  </a-form-item>
                </a-descriptions-item>
                <a-descriptions-item :span="3">
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      เวลาออกงาน
                      <span v-if="['เวลาออกงาน', 'ทั้งวัน'].includes(sel_type)" class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-form-item extra="" class="font-web mt-5 mb-0">
                    <a-time-picker :disabled="!(sel_type === 'ทั้งวัน' || sel_type === 'เวลาออกงาน')" format="HH:mm"
                      v-model="formTimeSave.end_time" />
                  </a-form-item>
                </a-descriptions-item>
              </a-descriptions>

              <h6 class="mt-20 mb-5 font-web">
                รายละเอียด <span class="text-danger">*</span>
              </h6>
              <p class="mb-10 text-muted font-web" style="font-size: 13px;">
                โปรดระบุรายละเอียด หรือข้อมูลเหตุผล เพื่อประกอบการพิจารณาอนุมัติของหัวหน้างาน
              </p>
              <a-form-item class="font-web" extra="">
                <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formTimeSave.reason" />
              </a-form-item>
              <a-form-item class="mt-0">
                <a-row class="font-web">
                  <a-col :xs="{ span: 24 }" :md="{ span: 8 }">
                    <a-button type="danger" @click="clearForm">
                      ยกเลิกการขอ
                    </a-button>
                  </a-col>
                  <a-col :style="{ textAlign: 'right' }" :xs="{ span: 12 }" :md="{ span: 8, offset: 8 }">
                    <span v-if="!['', null, 'null'].includes(formTimeSave.selected_date)">
                      <span v-if="sel_type === 'ทั้งวัน'">
                        <a-button type="primary" @click="dialogConfirm = true" class="font-web pa-10"
                          style="font-size: 14px" size="lg"
                          :disabled="(['', null, 'null'].includes(formTimeSave.start_time)) || (['', null, 'null'].includes(formTimeSave.end_time))">
                          ส่งคำขอเพิ่มเวลาทำงาน
                        </a-button>
                      </span>
                      <span v-if="sel_type === 'เวลาเข้างาน'">
                        <a-button type="primary" @click="dialogConfirm = true" class="font-web pa-10"
                          style="font-size: 14px" size="lg"
                          :disabled="['', null, 'null'].includes(formTimeSave.start_time)">
                          ส่งคำขอเพิ่ม เวลาเข้างาน
                        </a-button>
                      </span>
                      <span v-if="sel_type === 'เวลาออกงาน'">
                        <a-button type="primary" @click="dialogConfirm = true" class="font-web pa-10"
                          style="font-size: 14px" size="lg"
                          :disabled="['', null, 'null'].includes(formTimeSave.end_time)">
                          ส่งคำขอเพิ่ม เวลาออกงาน
                        </a-button>
                      </span>
                    </span>
                    <span v-else>
                      <a-button type="primary" class="font-web pa-10" style="font-size: 14px" size="lg" disabled>
                        ส่งคำขออนุมัติ
                      </a-button>
                    </span>

                  </a-col>
                </a-row>
              </a-form-item>

            </a-form>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <!-- dialog -->
    <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequest" @cancel="clearForm">
      <p v-if="boxTimeError.length === 0" class="mt-10 mb-20">
        Are you sure to Submit ?
      </p>
      <a-spin v-if="loading" tip="Loading..."></a-spin>
      <div v-if="boxTimeError.length !== 0">
        <a-alert :message="`Error The date you selected cannot be redeemed :: ${boxTimeError[0].type}`"
          :description="boxTimeError[0].detail" type="error" show-icon />
      </div>
    </a-modal>
  </div>
</template>

<script>
const form = {
  selected_date: null,
  start_time: "",
  end_time: "",
  reason: "",
};
import historyRequest from './history_request.vue';
export default {
  components: {
    historyRequest
  },
  data() {
    return {
      // history
      dataHomeRequest: [],
      //
      dialogConfirm: false,
      // form
      formTimeSave: Object.assign({}, form),
      sel_type: "ทั้งวัน",
      loading: false,
      endOpen: false,
      // error
      boxTimeError: [],
      // 
      dataHistory: [],
      loadingList: false
    };
  },
  watch: {
    sel_type(val) {
      this.formTimeSave.start_time = "";
      this.formTimeSave.end_time = "";
    },
  },
  mounted() {
    this.getAllRequest()
  },
  methods: {
    async getAllRequest() {
      this.loadingList = true
      this.dataHistory = []
      let aEnd = this.moment().add(1, "year").format("YYYY");
      let bStart = this.moment(`${Number.parseInt(this.moment().format("YYYY")) - 1}-10-01`).format(
        "YYYY-MM-DD"
      );
      let ee = this.moment(`${aEnd}-09-30`).format("YYYY-MM-DD");
      try {
        const res = await this.$http.get(
          `/hri/time-request/?timestart=${bStart}&timeend=${ee}`
        );
        if (res.status === 200) {
          this.dataHistory = res.data.sort((a, b) => {
            return b.id - a.id;
          })
          this.loadingList = false
        }
      } catch (error) {
        this.loadingList = false
      }
    },
    disabledBlockDate(date) {
      //   if(mset < 3){
      //   }else{
      //     }else{
      //   }else{
      // }else{
      let arr = [Number.parseInt(this.moment().format("MM")) - 1 <= 0 ? 12 : Number.parseInt(this.moment().format("MM")) - 1, Number.parseInt(this.moment().format("MM"))]
      if (arr.includes(Number.parseInt(date._d.getMonth() + 1))) {
        if (
          this.moment(date).format("YYYY-MM-DD") <=
          this.moment().format("YYYY-MM-DD")
        ) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    gotoMainType() {
      this.$router
        .push({
          path: "/hri/request",
        })
        .catch((err) => { });
    },
    clearForm() {
      this.dialogConfirm = false;
      this.formTimeSave = Object.assign({}, form);
      this.boxTimeError = [];
    },
    async submitRequest() {
      this.boxTimeError = [];
      this.loading = true;
      const sendData = new FormData();
      Object.entries(this.formTimeSave).forEach(([key, value]) => {
        if (["start_time", "end_time"].includes(key)) {
          if (!["", "null", null].includes(value)) {
            sendData.append(
              key,
              `${this.moment(this.formTimeSave.selected_date).format(
                "YYYY-MM-DD"
              )} ${this.moment(value, "HH:mm").format("HH:mm")}:00`
            );
          } else {
            sendData.append(key, "");
          }
        } else if (!["selected_date", "start_time", "end_time"].includes(key)) {
          sendData.append(key, value);
        }
      });

      try {
        const response = await this.$http.post(
          "/hri/time-request/add_request/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.loading = false;
          this.clearForm();
          this.$success({
            title: "This is a success message",
            content: (
              <div>
                <p class="mt-0 mb-0">
                  Success : send request ข้อมูลการบันทึกเวลา
                </p>
                <p class="mt-0 mb-0">(ข้อมูลของท่านถูกบันทึกเรียบร้อย)</p>
              </div>
            ),
          });
          this.$router
            .push({
              path: "/hri/",
            })
            .catch((err) => { });
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /hri/time-request/add_request/`,
        });
        this.boxTimeError.push(error.response.data);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 14px;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.form-sub-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.form-container {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  background: #ffffff;
}

.h-full {
  height: 100%;
}

.notice-savetime-box {
  border-radius: 8px;
  border: 1px solid #bae7ff;
  background-color: #f6fbff;
}

.notice-savetime-box ul {
  list-style-type: disc;
}
</style>